/* eslint-disable react/jsx-props-no-spreading */
import React, { useEffect, useRef, useState } from 'react'
import { useFormikContext } from 'formik'
import { isArray } from 'lodash'
import { agenda } from 'constants/Events'
import { Plus } from 'phosphor-react'
import { toast } from 'react-toastify'
import CustomToast from 'components/common/custom-toast/CustomToast'
import { alertTypes } from 'constants/Common'
import AgendaAccordionCard from './AgendaAccordionCard'

function AgendaStep() {
  const formik = useFormikContext()
  const [openAgendaIndex, setOpenAgendaIndex] = useState(0)
  const lastSubmitCountRef = useRef(0)

  useEffect(() => {
    const hasNewSubmitAttempt = formik.submitCount > lastSubmitCountRef.current
    if (hasNewSubmitAttempt && formik?.errors?.agenda) {
      toast(
        <CustomToast
          variant={alertTypes.DANGER}
          message='Please fill all the fields'
        />
      )
    }
    lastSubmitCountRef.current = formik.submitCount
  }, [formik.submitCount, formik.errors?.agenda])

  const handleAddAgenda = () => {
    const nextList = [...(formik.values.agenda || []), { ...agenda }]
    formik.setFieldValue('agenda', nextList)
    setOpenAgendaIndex(nextList.length - 1)
  }

  const handleAgendaChange = (index, field, value) => {
    const next = [...(formik.values.agenda || [])]
    next[index] = { ...next[index], [field]: value }
    formik.setFieldValue('agenda', next)
  }

  const handleDeleteAgenda = (index) => {
    const next = [...(formik.values.agenda || [])]
    next.splice(index, 1)
    formik.setFieldValue('agenda', next)
    if (!next.length) {
      setOpenAgendaIndex(0)
      return
    }
    setOpenAgendaIndex((prev) => Math.min(prev, next.length - 1))
  }

  return (
    <div className='event-create-card'>
      <p className='heading-lg mb-3'>Agenda</p>
      <div className='event-agenda-stack'>
        {(formik.values.agenda || []).map((item, index) => (
          <AgendaAccordionCard
            key={`agenda-${index}`}
            title={item?.title?.trim() || `Agenda Name-${index + 1}`}
            isOpen={openAgendaIndex === index}
            onToggle={() =>
              setOpenAgendaIndex((prev) => (prev === index ? -1 : index))
            }
            agendaItem={item}
            errors={formik?.errors?.agenda?.[index]}
            submitCount={formik.submitCount}
            onChange={(field, value) => handleAgendaChange(index, field, value)}
            onDelete={() => handleDeleteAgenda(index)}
          />
        ))}
      </div>
      <button type='button' className='event-speaker-add-btn' onClick={handleAddAgenda}>
        <Plus size={18} />
        <span>Add Agenda</span>
      </button>
      <p className='error-text'>
        {!isArray(formik?.errors?.agenda) &&
        typeof formik?.errors?.agenda !== 'object'
          ? formik?.errors?.agenda
          : ''}
      </p>
    </div>
  )
}

export default AgendaStep
